(function() {
  'use strict';

  var configEl = document.getElementById('cross-sell-config');
  if (!configEl) return;

  var offers;
  try {
    offers = JSON.parse(configEl.textContent);
  } catch(e) {
    return;
  }

  if (!Array.isArray(offers) || offers.length === 0) return;

  // Get current product handle from URL
  var currentHandle = null;
  var pathMatch = window.location.pathname.match(/\/products\/([^?#/]+)/);
  if (pathMatch) currentHandle = pathMatch[1];
  if (!currentHandle) return;

  // Find matching offer
  var activeOffer = null;
  for (var i = 0; i < offers.length; i++) {
    if (offers[i].triggerProductHandle === currentHandle) {
      activeOffer = offers[i];
      break;
    }
  }
  if (!activeOffer) return;

  // Build popup HTML
function buildPopupHTML(offer) {
    var benefitsHTML = '';
    if (offer.benefits && offer.benefits.length > 0) {
      benefitsHTML = '<ul class="cs-popup-benefits">';
      offer.benefits.forEach(function(b) {
        if (b && b.trim() !== '') {
          benefitsHTML += '<li>' +
            '<svg class="cs-popup-check" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<circle cx="12" cy="12" r="11" fill="#22C55E"/>' +
            '<path d="M7 12.5L10.5 16L17 9" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg>' +
            '<span>' + b + '</span>' +
            '</li>';
        }
      });
      benefitsHTML += '</ul>';
    }

    var layout = offer.layout || 'image-side';
    var bodyHTML = '';

    if (layout === 'image-top') {
      bodyHTML = '' +
        '<div class="cs-popup-body">' +
          '<div class="cs-popup-product cs-layout-top">' +
            '<div class="cs-popup-image cs-image-large">' +
              '<img src="' + offer.imageUrl + '" alt="' + offer.productTitle + '">' +
            '</div>' +
            '<div class="cs-popup-info cs-info-full">' +
              '<h3 class="cs-popup-product-title">' + offer.productTitle + '</h3>' +
              benefitsHTML +
            '</div>' +
          '</div>' +
          '<div class="cs-popup-price-box">' +
            '<span class="cs-popup-price-label">\u2728 Add this item for ' + offer.discountPercent + '% off!</span>' +
            '<span class="cs-popup-price-original">' + offer.originalPrice + '</span>' +
            '<span class="cs-popup-price-sale">' + offer.salePrice + '</span>' +
          '</div>' +
        '</div>';
    } else {
      bodyHTML = '' +
        '<div class="cs-popup-body">' +
          '<div class="cs-popup-product">' +
            '<div class="cs-popup-image">' +
              '<img src="' + offer.imageUrl + '" alt="' + offer.productTitle + '">' +
            '</div>' +
            '<div class="cs-popup-info">' +
              '<h3 class="cs-popup-product-title">' + offer.productTitle + '</h3>' +
              benefitsHTML +
            '</div>' +
          '</div>' +
          '<div class="cs-popup-price-box">' +
            '<span class="cs-popup-price-label">\u2728 Add this item for ' + offer.discountPercent + '% off!</span>' +
            '<span class="cs-popup-price-original">' + offer.originalPrice + '</span>' +
            '<span class="cs-popup-price-sale">' + offer.salePrice + '</span>' +
          '</div>' +
        '</div>';
    }

    return '' +
      '<div class="cs-popup-overlay" id="cs-popup-overlay">' +
        '<div class="cs-popup-modal">' +
          '<div class="cs-popup-header">' +
            '<span class="cs-popup-ribbon">SAVE ' + offer.discountPercent + '%</span>' +
            '<h2 class="cs-popup-title">' + offer.popupTitle + '</h2>' +
            '<button class="cs-popup-close" id="cs-popup-close" aria-label="Close">&times;</button>' +
          '</div>' +
          bodyHTML +
          '<div class="cs-popup-actions">' +
            '<button class="cs-popup-btn-add" id="cs-popup-add">' + offer.buttonText + '</button>' +
            '<button class="cs-popup-btn-no" id="cs-popup-no">No thanks</button>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  // Inject popup
  var popupContainer = document.createElement('div');
  popupContainer.innerHTML = buildPopupHTML(activeOffer);
  document.body.appendChild(popupContainer);

  var overlay = document.getElementById('cs-popup-overlay');
  var closeBtn = document.getElementById('cs-popup-close');
  var addBtn = document.getElementById('cs-popup-add');
  var noBtn = document.getElementById('cs-popup-no');

  function showPopup() {
    overlay.classList.add('cs-active');
    document.body.style.overflow = 'hidden';
  }

  function hidePopup() {
    overlay.classList.remove('cs-active');
    document.body.style.overflow = '';
  }

  function addToCart(variantId, quantity, callback) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    })
    .then(function(response) {
      if (!response.ok) throw new Error('Failed to add to cart');
      return response.json();
    })
    .then(function(data) {
      if (callback) callback(null, data);
    })
    .catch(function(err) {
      if (callback) callback(err);
    });
  }

  function getSelectedVariantId() {
    var select = document.querySelector('select[name="id"]');
    if (select) return parseInt(select.value, 10);
    var checkedRadio = document.querySelector('input[name="id"]:checked');
    if (checkedRadio) return parseInt(checkedRadio.value, 10);
    return null;
  }

  function getSelectedQuantity() {
    var qtyInput = document.querySelector('[data-quantity] input[type="number"], input[name="quantity"]');
    if (qtyInput) return parseInt(qtyInput.value, 10) || 1;
    return 1;
  }

  // Intercept ATC via button click (capturing phase - runs before Avenue's handler)
  function interceptATC() {
    var atcButtons = document.querySelectorAll('button[data-atc], button[name="add"]');

    atcButtons.forEach(function(btn) {
      if (btn._csIntercepted) return;
      btn._csIntercepted = true;

      btn.addEventListener('click', function(e) {
        // Ignore clicks from variant swatches
        if (e.target.closest('variant-swatch-king, .swatch-view-item, .swatch-selector, .swatch-image')) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        var mainVariantId = getSelectedVariantId();
        var mainQty = getSelectedQuantity();

        if (!mainVariantId) {
          alert('Please select a variant.');
          return;
        }

        addToCart(mainVariantId, mainQty, function(err) {
          if (err) {
            alert('Could not add to cart. Please try again.');
            return;
          }
          showPopup();
        });
      }, true);
    });
  }

  // "Add Serum" button
  addBtn.addEventListener('click', function() {
    addBtn.disabled = true;
    addBtn.textContent = 'Adding...';

    addToCart(activeOffer.crossSellVariantId, 1, function(err) {
      if (err) {
        addBtn.disabled = false;
        addBtn.textContent = activeOffer.buttonText;
        alert('Could not add to cart. Please try again.');
        return;
      }
      window.location.href = '/discount/' + activeOffer.discountCode + '?redirect=/cart';
    });
  });

  // "No thanks"
  noBtn.addEventListener('click', function() {
    hidePopup();
    window.location.href = '/cart';
  });

 closeBtn.addEventListener('click', function() {
    hidePopup();
  });

  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) {
      hidePopup();
    }
  });

document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.classList.contains('cs-active')) {
      hidePopup();
    }
  });

  // Init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', interceptATC);
  } else {
    interceptATC();
  }

  setTimeout(interceptATC, 1500);
  setTimeout(interceptATC, 3000);
})();